import React, { useState } from 'react';
import DatePicker from 'react-date-picker'
import { ownerEmail } from '../../config.js'

import { TextInput, Card, MultilineInput, StandardButton, TabLink, sendEmail, Alert} from '../../shared'
import UnitTable from './UnitTable.js'
import { emailSubject, getHtmlBody } from './constants.js'

import css from './Reservation.module.scss'

const Reservation = () => {
  const [reservationState, setReservationState] = useState({
    name: '',
    email: '',
    number: '',
    selectedRow: 0,
    date: null,
    comments: '',
    success: false,
    error: false
  })
  const storageSizes = ['Unspecified','5x10','10x10','10x15']


// State Changes Start
  const onDateChange = (date) => {
    setReservationState({
      ...reservationState,
      date: date
    })
  }

  const onNameChange = (e) => {
    setReservationState({
      ...reservationState,
      name: e.target.value
    })
  }

  const onEmailChange = (e) => {
    setReservationState({
      ...reservationState,
      email: e.target.value
    })
  }

  const onNumberChange = (e) => {
    setReservationState({
      ...reservationState,
      number: e.target.value
    })
  }

  const onCommentChange = (e) => {
    setReservationState({
      ...reservationState,
      comments: e.target.value
    })
    console.log(reservationState.comments)
  }

  const onTableChange = (index) => {
    setReservationState({
      ...reservationState,
      selectedRow: index
    })
  }

  const resetSuccess = () => {
    setReservationState({
      ...reservationState,
      success: false,
      error: false
    })
  }

  const setSuccessful = () => {
    setReservationState({
      ...reservationState,
      name: '',
      email: '',
      number: '',
      selectedRow: 0,
      date: null,
      comments: '',
      success: true,
      error:false
    })
  }

  const onError = () => {
    setReservationState({
      ...reservationState,
      success: false,
      error: true
    })
  }

  // State Changes End
  const handleSuccess = () => {
    setSuccessful()
  }

const ownerEmailConfig = {
  sourceEmail: ownerEmail,
  destinationEmails: [ownerEmail],
  ccEmails: [],
  templateName: 'communitylocker',
  templateData: {
    name: reservationState.name,
    email: reservationState.email,
    number: reservationState.number==='' ? 'Unspecified':reservationState.number,
    storageSize: storageSizes[reservationState.selectedRow],
    date: reservationState.date ? reservationState.date : 'Unspecified',
    comments: reservationState.comments==='' ? 'Unspecified':reservationState.comments
  },
  onSuccess: handleSuccess,
  onError: onError
}

const submitEmail = (ownerEmailConfig) => {
  resetSuccess()
  window.open(`mailto:CommunityLockerSS@gmail.com?subject=${emailSubject}&body=${getHtmlBody({
    name: reservationState.name,
    email: reservationState.email,
    number: reservationState.number==='' ? 'Unspecified':reservationState.number,
    storageSize: storageSizes[reservationState.selectedRow],
    date: reservationState.date ? reservationState.date : 'Unspecified',
    comments: reservationState.comments==='' ? 'Unspecified':reservationState.comments
  })}`, '_blank', 'noopener,noreferrer');
  // Diabling auto send
  // sendEmail(ownerEmailConfig)
}

const alertDismissHandler = () => {
  resetSuccess()
}

  const alertText = reservationState.success
    ? 'Successfully made reservation! A representative will reach out to you shortly.'
    : 'Error in making your reservation. Please try again.'

  return (
    <div>
      <Alert
        text={alertText}
        hidden={!(reservationState.success || reservationState.error)}
        dismissHandler={alertDismissHandler}
        type={reservationState.success ? 'success' : 'error'}/>
      <div className={css.reservation}>
        <div className={css.marginRight}>
          <Card>
            <div className={css.cardLeft}>
              <TextInput placeholder="Full Name (required)" value={reservationState.name} changeHandler={(e) => {onNameChange(e)}}/>
              <TextInput
                placeholder="Email Address (required)"
                value={reservationState.email}
                changeHandler={(e)=>{onEmailChange(e)}}
                disableAutocorrect
              />
              <TextInput placeholder="Phone Number" value={reservationState.number} changeHandler={(e)=>{onNumberChange(e)}} />
              <div className={css.shrink}>
                <div className={css.marginTop}>Date Needed</div>
                <DatePicker onChange={onDateChange} value={reservationState.date} className={css.datePicker}/>
              </div>
              <MultilineInput placeholder="Comments and Questions" value={reservationState.comments} changeHandler={(e)=>{onCommentChange(e)}} />
              <div className={`${css.shrink} ${css.end}`}>
                <StandardButton
                  text={reservationState.selectedRow===0 ? "Submit Without Unit Selection" : "Submit"}
                  clickHandler={() => {submitEmail(ownerEmailConfig)}}
                  disabled={(reservationState.name === '')||(reservationState.email === '')} />
              </div>
            </div>
          </Card>
        </div>
        <div className={css.overflow}>
          <Card>
            <div className={css.scroll}><UnitTable selectedRow={reservationState.selectedRow} clickHandler={onTableChange}/></div>
            <TabLink text='Help in choosing unit size' route='storage_tips' />
          </Card>
        </div>
      </div>
    </div>
  )
}

export default Reservation;
